/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholders_EmailInputs */

const en_placeholders_email = /** @type {(inputs: Placeholders_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter email address`)
};

/**
* | output |
* | --- |
* | "Enter email address" |
*
* @param {Placeholders_EmailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const placeholders_email = /** @type {((inputs?: Placeholders_EmailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholders_EmailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_placeholders_email(inputs)
});